<template>
    <div>
        <!--顶部标题菜单-->
        <div class = "header">
            <p class = "h_title">{{txtLang[langName]['market']}}</p>
            <div class = "h_btn " >
                <a :class = "noticeNum > 0 ? 'redPoint' : ''" @click="hideSide" href = "javascript:void(0)">
                    <img src = "../../static/image/icon_menu.png"/>
                </a>
            </div>
        </div>

        <!--个人信息-->
        <div class = "person" :class = "lxHide ? 'personTop' : ''">
            <div class = "p_box flex flex-align-center">
                <div class = "pb_left">
                    <img src = "../../static/image/icon_coin.png" />
                    <p>{{txtLang[langName]['myCoins']}}</p>
                </div>
                <div v-if = "ifLogin" class = "pb_num flex-1">
                    <p>{{moneyStr(userInfo.coins)}}</p>
                </div>
                <div v-else class = "pb_loginBtn flex-1">
                    <a @click="toGo">{{txtLang[langName]['login']}}</a>
                </div>
                <div class = "pb_right" v-if = "ifLogin">
                    <span class="m-coins">{{txtLang[langName]['myCoupon']}}</span>
                    <span class="m-num">{{moneyStr(userInfo.tickets)}}</span>
                </div>
            </div>
        </div>

        <!--轮显-->
        <div class = "lx" :class = "lxHide ? 'lxHide' : ''" ref="lx">
            <div class = "l_box">
                <lx :arr = "lx"></lx>
            </div>
        </div>

        <!---->
        <div class="exchange-nav">
            <span>{{txtLang[langName]['giftChange']}}</span>
            <router-link :to="{name: 'Exchange'}" v-if="ifLogin">{{txtLang[langName]['changeRecord']}}</router-link>
            <a @click="toGo" v-else-if="ifLogin==false">{{txtLang[langName]['changeRecord']}}</a>
        </div>

        <!--奖品列表-->
        <div class="award-box">
            <ul class="award-list" v-if="isLoadingShow == false && exchangeList.length > 0">
                <li v-for="(val,key) in exchangeList" :class="val.num == 0 ? 'award-left-0' : ''">
                    <div class="award-img"><img :src="val.image" /></div>
                    <div class="award-info">
                        <h5 class="award-title">{{val.title}}</h5>
                        <p class="award-prize">{{moneyStr(val.value)}}</p>
                        <p :class="['award-handle', ifLogin ? '' : 'award-padding']" v-if="val.num > 0">
                            <span class="award-bar"><i :style="{width: (userInfo.tickets>=val.value ? '100' : (userInfo.tickets/val.value).toFixed(2)*100) + '%'}" v-if="ifLogin"></i></span>
                            <a v-if="ifLogin && userInfo.tickets >= val.value" class="award-btn" @click="exchangeConfirm({'id': val.id,'val': val.value})">{{txtLang[langName]['changeBtn']}}</a>
                            <span v-else-if="ifLogin && userInfo.tickets < val.value" class="award-need"><b><em>{{stringSub(txtLang[langName]['needMore'], '#p', (val.value-userInfo.tickets))}}</em></b></span>
                        </p>
                        <p class="award-tips" v-if="ifLogin == false">{{stringSub(txtLang[langName]['changeTips'], '#p', val.value)}}</p>
                    </div>
                    <span class="award-left" v-if="val.num <= 10">{{stringSub(txtLang[langName]['changeLeft'], '#p', val.num)}}</span>
                </li>
            </ul>
            <noneBox v-else-if = "isLoadingShow == false && exchangeList.length == 0" :noData="txtLang[langName]['noData']"></noneBox>
        </div>

        <!--loading-->
        <Loading v-show="isLoadingShow"></Loading>
        <!--confirm层-->
        <confirm ref="myConfirm"></confirm>
        <!--侧边栏-->
        <sideBar ref="Model"></sideBar>
    </div>
</template>

<script>
    import Loading from './common/Loading';
    import Lx from './common/Lx';
    import sideBar from './sideBar';
    import confirm from './common/Confirm';
    import noneBox from './common/None';
    import qs from 'qs';

    export default {
        name: "mallIndex",
        components:{
            Loading,
            Lx,
            sideBar,
            confirm,
            noneBox
        },

        data(){
            return {
                isLoadingShow: true,
                alertTip:'',//alert文本
                ifLogin:false,//是否登录
                //轮显
                lx:[],
                lxMax:6,//轮显最大值
                lxHide:false,//轮显是否隐藏
                lxHeight:0,//轮显高度
                userInfo: {},//用户信息
                exchangeList: []//兑换好礼列表
            }
        },

        methods: {
            hideSide(){//侧边栏隐藏
                this.$refs.Model.hideSide();
            },

            /**
             * 登录跳转
             */
            toGo: function(){
                this.gotoLogin();
            },

            loadLx(){//读取轮显
                this.axios.get(this.getHost() + '/banner/list?lan=' + this.langIndex).then(
                    (response)=>{
                        var re = response.data;
                        if(re.code == 200){
                            var arr = [];
                            for(var i = 0;i < re.data.length && i < this.lxMax;i++){
                                arr.push(re.data[i]);
                                this.lx.push(re.data[i]);
                            }
                            
                        }
                        else if(re.code == 401){
                            this.toLogin();
                        }
                        else{
                            alert(re.message);
                        }
                    }).catch((response)=>{
                    //console.log(response);
                });
            },

            /**
             * 商城主页数据读取
             */
            loadData: function(options){
                var defaults = {
                    token: '',
                    lan: 'en'
                };

                defaults = Object.assign(defaults, options);

                const that = this;
                that.isLoadingShow = true;

                this.axios.get(this.getHost() + "/mall/home?lan="+defaults.lan+'&token='+defaults.token).then((response) => {
                    that.isLoadingShow = false;

                    var re = response.data;
                    if(re.code == 200){
                        that.userInfo = re.data.user;
                        that.exchangeList = re.data.exchange_list;
                        this.noticeNum = re.data.noticeNum;
                    }
                }).catch((response) => {
                    console.log(response)
                });
            },

            /**
             * 兑换
             */
            exchangeConfirm: function(obj){
                const that = this;

                that.$refs.myConfirm.show(this.stringSub(this.txtLang[this.langName]['confirmExchange'], '#p', obj.val), {
                    confirmText: this.txtLang[this.langName]['confirmText'],
                    cancelText: this.txtLang[this.langName]['confirmCancel'],
                    titleText: this.txtLang[this.langName]['confirmTitle'],
                    data: function(){
                        this.axios.post(this.getHost() + '/mall/'+ obj.id +'/exchange', qs.stringify({
                            token: localStorage.getItem('guess_token'),
                            lan: this.langIndex
                        })).then(
                            (response) => {
                                var re = response.data;

                                if(re.code == 200){
                                    that.$refs.myConfirm.show(this.txtLang[this.langName]['confirmSuccessTips'], {
                                        type: 'alert',
                                        titleType: 1,
                                        confirmText: this.txtLang[this.langName]['confirmNow'],
                                        titleText: this.txtLang[this.langName]['confirmSuccessTitle'],
                                        data: function(){
                                            that.loadData({
                                                token: localStorage.getItem('guess_token'),
                                                lan: this.langIndex,
                                            });
                                        }
                                    });
                                }else{
                                    that.$refs.myConfirm.show(this.txtLang[this.langName]['confirmErrorTips'], {
                                        type: 'alert',
                                        titleType: 2,
                                        confirmText: this.txtLang[this.langName]['confirmNow'],
                                        titleText: this.txtLang[this.langName]['confirmErrorTitle']
                                    });
                                }
                            }
                        ).catch(
                            (response) => {
                                console.log(response)
                            }
                        );
                    }
                });
            }

        },

        mounted(){//初始化
            const that = this;
            this.isUserLogin({
                source: this.source[this.langName],
                platform: 2,
                success: function(data){
                    if(data == 1){
                        that.ifLogin = true;
                    }else{
                        /*that.isLoadingShow = false;
                        that.gotoLogin();
                        return;*/
                    }
                    that.loadLx();
                    that.loadData({
                        token: localStorage.getItem('guess_token'),
                        lan: that.langIndex,
                    });
                }
            });
        }
    }
</script>

<style scoped>
    /*红点*/
    .redPoint{position:relative}
    .redPoint:after{top:-10px;right:-10px;position:absolute;display:block;content:'';background:#fb5051;width:20px;height:20px;border-radius:200px}
    /*头部*/
    .header{z-index:100;position:fixed;top:0;left:0;width:100%;height:120px;background:#232048}
    .header .h_title{font-size:40px;color:#fff;line-height:120px;text-align:center}
    .header .h_btn{width:120px;height:120px;position:absolute;top:0;left:0}
    .header .h_btn a{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%)}
    .header .h_btn a img{width:28px;height:28px}
    /*金币栏*/
    .person{padding-top:120px;width:100%;background:#131229;}
    .personTop{height:116px}
    .person .p_box{height:116px;padding:0 55px;font-size:0;position:relative}
    .person .p_box .pb_left{text-align:center;display:inline-block;margin-right:12px}
    .person .p_box .pb_left img{display:block;width:40px;height:40px;margin:0 auto}
    .person .p_box .pb_left p{color:#bbbabf;font-size:18px;}
    .person .p_box .pb_num p{display:inline-block;font-size:30px;color:#fd7446;font-weight:bold;}
    .person .p_box .pb_loginBtn a{display:block;border-radius:30px;width:200px;height:58px;text-align:center;line-height:58px;background:#6371ea;color:#fff;font-size:30px;}
    .person .p_box .pb_right{font-size:0;}
    .person .p_box .pb_right span{display:inline-block;}
    .m-coins{padding-top:32px;margin-right:10px;color:#bbbabf;font-size:18px;vertical-align:middle;background:url(../../static/image/icon_coupon.png) no-repeat center 0;background-size:auto 28px;}
    .m-num{color:#d476e2;font-size:30px;font-weight:bold;vertical-align:middle;}
    /*轮显*/
    .lx{transition:all 0.2s;-webkit-transition:all 0.5s;-moz-transition:all 0.5s;-ms-transition:all 0.5s;-o-transition:all 0.5s;width:100%;}
    .lxHide{opacity:0;height:0}
    .lx .l_box{padding:0 24px}
    /*  */
    .exchange-nav{display:flex;padding:0 55px;margin-top:30px;}
    .exchange-nav span{flex:1;color:#fff;font-size:30px;}
    .exchange-nav a{flex:1;color:#6371ea;font-size:24px;text-align:right;}
    /* 奖品列表 */
    .award-box{padding:0 22px;}
    .award-list{padding-top:22px;}
    .award-list li{display:flex;padding:28px 32px;margin-bottom:22px;border-radius:16px;background:#232048;position:relative;}
    .award-list li.award-left-0{background:#46464c;}
    .award-list li>div{vertical-align:top;}
    .award-img{flex:none;width:200px;height:120px;margin-right:24px;border-radius:16px;overflow:hidden;}
    .award-img img{width:100%;}
    .award-info{flex:1;}
    .award-title{color:#fff;font-size:24px;font-weight:normal;word-break: break-word;}
    .award-prize{padding-left:38px;color:#d476e2;font-size:24px;font-weight:bold;background:url(../../static/image/coupon_i.png) no-repeat 0 center;background-size:31px auto;}
    .award-handle{font-size:0;}
    .award-bar{display:inline-block;width:240px;height:16px;border-radius:16px;background:#3b3860;vertical-align:middle;}
    .award-bar i{display:inline-block;width:50%;height:16px;border-radius:16px;background:#d476e2;vertical-align:top;}
    .award-btn{display:inline-block;width:160px;height:58px;line-height:58px;margin-left:16px;color:#fff;font-size:24px;text-align:center;border-radius:10px;background:#6371ea;vertical-align:middle;}
    .award-need{display:inline-block;width:160px;height:58px;margin-left:16px;vertical-align:middle;}
    .award-need b{display:table;height:58px;font-weight:normal;}
    .award-need em{display:table-cell;line-height:30px;color:#bbbabf;font-size:18px;font-style:normal;text-align:center;vertical-align:middle;}
    .award-tips{line-height:28px;padding-top:10px;color:#d476e2;font-size:18px;}
    .award-padding{padding-top:22px;}
    .award-left{display:inline-block;padding:0px 14px;color:#fff;font-size:16px;background:#fb5051;border-radius:16px 0 20px 0;position:absolute;top:0;left:0;}
    .award-left-0 .award-left{color:#fefefe;background:#97979d;}
</style>


// WEBPACK FOOTER //
// src/components/mallIndex.vue